export default "__VITE_ASSET__2551c469__"